import * as React from "react";
import "./Certificate.css";

import Certificate1 from "../../assets/FSSAI PONVEL EXIM.png";
import Certificate2 from "../../assets/PONVEL EXIM FIEO.png";

import {
  ImageList,
  ImageListItem,
  Dialog,
  IconButton,
  Box,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DownloadIcon from "@mui/icons-material/Download";
import { Helmet } from "react-helmet-async";
export default function CertificateList() {
  <Helmet>
    <title>
      Certificates & Accreditations – Ponvel Exim | Quality Assurance
    </title>
    <meta
      name="description"
      content="View Ponvel Exim’s certificates, accreditations, and quality standard documents, showcasing our compliance and excellence in exports across food, FMCG, coir, and textiles."
    />
    <meta
      name="keywords"
      content="Ponvel Exim certificates, export certifications, quality accreditations, ISO certificates, HACCP, FSSAI, FIEO"
    />
    <link rel="canonical" href="https://ponvelexim.com/certificate" />

    {/* Open Graph */}
    <meta property="og:site_name" content="Ponvel Exim" />
    <meta property="og:locale" content="en_IN" />
    <meta
      property="og:title"
      content="Certificates & Accreditations – Ponvel Exim | Quality Assurance"
    />
    <meta
      property="og:description"
      content="Explore Ponvel Exim’s library of certifications and accreditations that demonstrate our export quality and compliance."
    />
    <meta property="og:image" content="https://ponvelexim.com/logo192.png" />
    <meta property="og:url" content="https://ponvelexim.com/certificate" />
    <meta property="og:type" content="website" />

    {/* Twitter */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta
      name="twitter:title"
      content="Certificates & Accreditations – Ponvel Exim"
    />
    <meta
      name="twitter:description"
      content="Check Ponvel Exim’s official export certifications and quality standard accreditations."
    />
    <meta name="twitter:image" content="https://ponvelexim.com/logo192.png" />
  </Helmet>;

  const itemData = [
    { img: Certificate1, title: "FSSAI PONVEL EXIM CERTIFICATE" },
    { img: Certificate2, title: "FIEO PONVEL EXIM CERTIFICATE" },
  ];

  const theme = useTheme();

  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  let cols = 4;
  if (isXs) cols = 1;
  else if (isSm) cols = 2;
  else if (isMdUp) cols = 4;

  const [open, setOpen] = React.useState(false);
  const [activeIndex, setActiveIndex] = React.useState(null);

  const handleOpen = (idx) => {
    setActiveIndex(idx);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const goNext = () => setActiveIndex((i) => (i + 1) % itemData.length);
  const goPrev = () =>
    setActiveIndex((i) => (i - 1 + itemData.length) % itemData.length);

  React.useEffect(() => {
    function onKey(e) {
      if (!open) return;
      if (e.key === "ArrowRight") goNext();
      if (e.key === "ArrowLeft") goPrev();
      if (e.key === "Escape") handleClose();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <>
      <ImageList cols={cols} gap={10} className="picture-section">
        {itemData.map((item, idx) => (
          <ImageListItem key={item.img}>
            <button
              onClick={() => handleOpen(idx)}
              className="picture-trigger"
              aria-label={`Open ${item.title}`}>
              <img
                src={item.img}
                alt={item.title}
                loading="lazy"
                className="picture-thumb"
              />
            </button>
          </ImageListItem>
        ))}
      </ImageList>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
        PaperProps={{ className: "lightbox-paper" }}>
        {activeIndex !== null && (
          <Box className="lightbox-root">
            <IconButton
              aria-label="Close"
              onClick={handleClose}
              className="icon-btn lightbox-close">
              <CloseIcon />
            </IconButton>
            <IconButton
              aria-label="Previous"
              onClick={goPrev}
              className="icon-btn lightbox-prev">
              <ArrowBackIosNewIcon />
            </IconButton>
            <IconButton
              aria-label="Next"
              onClick={goNext}
              className="icon-btn lightbox-next">
              <ArrowForwardIosIcon />
            </IconButton>
            <Box className="lightbox-stage">
              <img
                src={itemData[activeIndex].img}
                alt={itemData[activeIndex].title}
                className="lightbox-image"
              />
            </Box>
            <Box className="lightbox-caption">
              <div className="lightbox-title">
                {itemData[activeIndex].title}
              </div>
              <a
                href={itemData[activeIndex].img}
                download
                className="lightbox-download-link">
                <Button
                  size="small"
                  variant="contained"
                  startIcon={<DownloadIcon />}
                  className="lightbox-download-btn">
                  Download
                </Button>
              </a>
            </Box>
          </Box>
        )}
      </Dialog>
    </>
  );
}
